export class ClicksDetector {
  private readonly listener = this.detectClickOnIframe.bind(this);

  constructor(
    private readonly slotName: string,
    private readonly callbackOnDetection: () => void,
  ) {}

  init(): void {
    window.addEventListener("blur", this.listener);
  }

  /**
   * Detects clicks on an iframe by checking if the currently active element
   * is within a specific slot (identified by its name).
   *
   * - Escapes the `slotName` using `CSS.escape()` to handle special characters
   *   in slot names (e.g., '/' in out-of-page slots like 'interstitial').
   *   @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CSS/escape}
   * - If a click is detected within the slot, the provided callback function
   *   (`callbackOnDetection`) is executed.
   * - Clears the detection by blurring the active element after a short delay.
   */
  private detectClickOnIframe() {
    const elem = document.activeElement;
    // We need to escape the slotName for outOfPage slots that include '/' in their slot names, such as the 'interstitial' slot. We can accomplish this by using the CSS.escape() function.
    const newClickDetected =
      elem?.closest(`div#${CSS.escape(this.slotName)}`) !== null;

    if (!newClickDetected) {
      return;
    }

    this.callbackOnDetection();
    this.clearDetection();
  }

  private clearDetection(): void {
    setTimeout(() => {
      (document.activeElement as HTMLBodyElement).blur();
    }, 100);
  }

  detach(): void {
    window.removeEventListener("blur", this.listener);
  }
}
